import * as _ from 'underscore';

import { GetServerInfoRequest, IGetServerInfoResult } from '../requests/GetServerInfoRequest';

import { Host } from '../types/Host';
import { WorkerProcess } from '../types/WorkerProcess';
import { Messages } from '../../codegen/Localize';
import { toNativePromise } from '../../commonInfra/utils/QUtils';
import WebHttpClient from '../../httpClient/WebHttpClient';

export namespace ServerInfoService {

  export function fetch(): Promise<Host[]> {
    return WebHttpClient.sendRequest(new GetServerInfoRequest({}))
      .then<Host[]>((result: IGetServerInfoResult) => {
        return makeHosts(result);
      });
  }

  // Transform the array of ServerComponentProcesses into an ordered array of Hosts
  function makeHosts(result: IGetServerInfoResult): Host[] {
    const groupedByHosts: _.Dictionary<WorkerProcess[]> = _.groupBy(result.processes, 'host');
    const hosts = _.map(result.workerHosts, (hostName: string) => {
      const host: Host = {
        name: hostName,
        processes: _.groupBy(groupedByHosts[hostName], 'type'),
        isExternal: false,
      };
      return host;
    });

    // External hosts are those that host services but are not part of the cluster.
    const externalHosts = _.keys(groupedByHosts).filter((x: string) => result.workerHosts.indexOf(x) === -1);
    if (externalHosts.length > 0) {
      // We are going to merge all the external hosts into one called 'external'
      const externalProcesses: WorkerProcess[] = _.flatten(_.map(externalHosts, (hostName: string) => groupedByHosts[hostName]));
      // Mark all the processes as external
      _.forEach(externalProcesses, (x: WorkerProcess) => x.isExternal = true);
      const externalHost: Host = {
        name: Messages.externalNodeName(),
        processes: _.groupBy(externalProcesses, 'type'),
        isExternal: true,
      };
      hosts.push(externalHost);
    }

    return hosts;
  }

}

export type ServerInfoService = typeof ServerInfoService;
